import { TranslationObject } from 'types/translations'

const FALLBACK_LOCALES: (keyof TranslationObject)[] = ['it', 'en', 'de', 'es', 'zh', 'fr']

export function getTranslation(translationObject: TranslationObject | undefined, locale: string): string | undefined {
  if (!translationObject) return undefined

  const localized = translationObject[locale as keyof TranslationObject]?.trim()
  if (localized) return localized

  for (const fallback of FALLBACK_LOCALES) {
    const value = translationObject[fallback]?.trim()
    if (value) return value
  }

  return undefined
}
